import { NotificationModel } from '../../ts/interfaces/models/NotificationModel';
import { Notification } from '../../ts/types/Notification';

export const parseNotificationModelToNotification = (notifications: NotificationModel[]): Notification[] => {
  const parsedNotifications = notifications.map(({ title, not_read, user_id, createdAt }) => {
    const date = createdAt ? new Date(createdAt) : null;
    return {
      title,
      notRead: not_read,
      user_id: user_id,
      createdAt: date ? date.toLocaleDateString('en-US') : '',
    };
  });
  return parsedNotifications;
};
